import Box from '@mui/material/Box';
import { SxProps, Theme } from '@mui/material/styles';
import { SystemStyleObject } from '@mui/system/styleFunctionSx/styleFunctionSx';
import React from 'react';

export interface ContainerProps {
  readonly children: React.ReactNode;
  readonly sx?: SxProps<Theme>;
}

export const Container: React.FC<ContainerProps> = (props: ContainerProps): React.ReactElement => {
  const { children, sx } = props;

  return <Box sx={[styles.container, ...(Array.isArray(sx) ? sx : [sx])]}>{children}</Box>;
};

const styles: Record<string, SystemStyleObject> = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    height: '100%',
    gap: 2,
  },
};
